export default "__VITE_ASSET__b65a2a72__"